/**
 * Helpers to create and revoke blob URLs without leaking memory.
 */

export function revokeBlobUrl(url) {
  if (typeof url === 'string' && url.startsWith('blob:')) {
    try {
      URL.revokeObjectURL(url);
    } catch (_) {
      /* ignore */
    }
  }
}

export function revokeBlobUrls(urls) {
  if (!urls) return;
  if (Array.isArray(urls)) {
    urls.forEach(revokeBlobUrl);
    return;
  }
  if (typeof urls === 'object') {
    Object.values(urls).forEach(revokeBlobUrl);
  }
}

/** Cap an array of edit URLs; revoke any dropped blob: entries. */
export function appendCappedUrls(prev, nextUrl, max = 20) {
  const next = [...(prev || []), nextUrl];
  if (next.length <= max) return next;
  const dropped = next.splice(0, next.length - max);
  revokeBlobUrls(dropped);
  return next;
}
